import { sendEzspmByLink } from "tyrande";
import { tryDecodeURIComponent } from "./browser/uri";
import { Platform } from "utils/runtime";

export interface PrmParams {
	floor: number;
	position?: number;
	platform?: Platform;
}

export const sendPrmByUrl = (link: string = "") => {
	if (!link.startsWith("#")) {
		sendEzspmByLink(tryDecodeURIComponent(link), false);
	}
};
